// src/viewmodels/useNavViewModel.js
import { useState, useEffect, useCallback } from 'react';

export function useNavViewModel() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  // Close drawer on resize to desktop
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 768) setMobileOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Track scroll for navbar affix & active section
  useEffect(() => {
    const sectionNavMap = [
      { id: 'home', navId: 'home' },
      { id: 'about', navId: 'about' },
      { id: 'skills', navId: 'skills' },
      { id: 'service', navId: 'skills' },
      { id: 'portfolio', navId: 'portfolio' },
      { id: 'projects', navId: 'portfolio' },
      { id: 'case-studies', navId: 'case-studies' },
      { id: 'casestudies', navId: 'case-studies' },
      { id: 'experience', navId: 'experience' },
      { id: 'hire-me', navId: 'experience' },
      { id: 'publications', navId: 'publications' },
      { id: 'blog', navId: 'blog' },
      { id: 'gallery', navId: 'blog' },
      { id: 'contact', navId: 'contact' },
    ];

    const onScroll = () => {
      // 1. Scrolled state for navbar affix
      setScrolled(window.scrollY > 20);

      // 2. Active section detection
      // Top of the page
      if (window.scrollY < 80) {
        setActiveSection('home');
        return;
      }

      // Bottom of the page (near footer)
      const scrollBottom = window.innerHeight + window.scrollY;
      const docHeight = document.documentElement.scrollHeight;
      if (scrollBottom >= docHeight - 80) {
        setActiveSection('contact');
        return;
      }

      // Check sections based on target line (140px below top, under navbar)
      const targetLine = 140;
      let matchedNavId = 'home';

      for (const { id, navId } of sectionNavMap) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= targetLine) {
            matchedNavId = navId;
          }
        }
      }

      setActiveSection(matchedNavId);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // Run once on mount

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const toggleMobile = useCallback(() => setMobileOpen((prev) => !prev), []);
  const closeMobile = useCallback(() => setMobileOpen(false), []);

  return { mobileOpen, scrolled, activeSection, setActiveSection, toggleMobile, closeMobile };
}
